"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayHubIntegrationModule = void 0;
class PlayHubIntegrationModule {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async listISPS() {
        const { data } = await this.axiosInstance.get("/api/v1/playhub/isps/");
        return data;
    }
    async login(username, password, isp) {
        const { data } = await this.axiosInstance.post("/api/v1/playhub/login/", {
            username,
            password,
            isp,
        });
        return data;
    }
}
exports.PlayHubIntegrationModule = PlayHubIntegrationModule;
//# sourceMappingURL=playhub.js.map